import { render } from "./payment-cart.vue?vue&type=template&id=5d33d432"
import script from "./payment-cart.vue?vue&type=script&lang=js"
export * from "./payment-cart.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__